"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    transform: "matrix(0.78394003,0,0,0.78394003,-0.05978605,2.243154)",
    strokeWidth: "2.55121565",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
      y2: "6",
      x2: "16",
      y1: "2",
      x1: "16",
      strokeWidth: "2.55121565",
      strokeMiterlimit: "4",
      strokeDasharray: "none"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
      y2: "6",
      x2: "8",
      y1: "2",
      x1: "8",
      strokeWidth: "2.55121565",
      strokeMiterlimit: "4",
      strokeDasharray: "none"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
      y2: "10",
      x2: "21",
      y1: "10",
      x1: "3",
      strokeWidth: "2.55121565",
      strokeMiterlimit: "4",
      strokeDasharray: "none"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M 21.437814,12.544765 21.399592,4.3560654 H 2.1786533 V 22.432899 H 21.32721 v -3.629742",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.55121565",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      strokeOpacity: "1"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    transform: "matrix(0.51592034,0,0,0.51592034,15.308824,8.6910069)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "3.87656736",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      stroke: "currentColor",
      strokeWidth: "3.87656736",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      transform: "translate(5,5)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M -8.7351389,6.2031319 H 9.149603",
        strokeWidth: "3.87656736",
        strokeMiterlimit: "4",
        strokeDasharray: "none"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
        points: "7 0 14 7 7 14",
        strokeWidth: "4.28707409",
        strokeMiterlimit: "4",
        strokeDasharray: "none",
        transform: "matrix(0.90424553,0,0,0.90424553,-3.5098345,-0.12658686)"
      })]
    })
  })]
}));